import React, { useEffect, useState } from "react";
import ViewAll from "./ViewAll";
import { useTranslation } from "react-i18next";
import { LABELKEYS_SEARCH_RESULTS } from "../../../helper/constants";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { ScrollPositionActions } from "../../../storage/reducers/scrollPositionReducer";
import { parseToLink } from "../../../assets/js/utils";
import "./MetaDataDisplay.scss";

const MetaDataDisplay = (props: any) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const scrollPositionLevel = useSelector((state: any) => {
    return state?.scrollPositionLevel?.scrollPosition;
  });

  const scrollPositionValid = useSelector((state: any) => {
    return state?.scrollPositionLevel?.scrollValid;
  });
  useEffect(() => {
    if (scrollPositionValid?.[pathname]) {
      window.scrollTo(0, scrollPositionLevel?.[pathname]);
      if (pathname === "/") {
        const updatedScrollPosition = { ...scrollPositionValid };
        delete updatedScrollPosition?.[pathname];
        dispatch(
          ScrollPositionActions.getScrollPosition({
            scrollValid: updatedScrollPosition,
          })
        );
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  const isPartNumber = props.label === "Part Numbers";
  const partNumberValues = Array.isArray(props.data)
    ? props.data
    : props.data !== null && props.data !== undefined
    ? [props.data]
    : [];
  const isNA =
    isPartNumber &&
    partNumberValues.length > 0 &&
    partNumberValues.every(
      (d) => String(d ?? "").trim().toUpperCase() === "N/A"
    );

  // TEMP DEBUG — remove once confirmed. Check the browser console for this
  // exact line when viewing a "Part Numbers: N/A" row, and report back what
  // it prints — that's the one piece of evidence needed to fix this for real
  // instead of guessing at the data shape again.
  if (isPartNumber) {
    console.log("MetaDataDisplay Part Numbers debug:", {
      rawData: props.data,
      isArray: Array.isArray(props.data),
      partNumberValues,
      isNA,
    });
  }

  return (
    <div className="sub-head metafield">
      <div className="metafieldLeft">
        <span>{` ${props.label}: `}</span>
      </div>
      <div className="metafieldright" >
        <span
          className={
            isPartNumber
              ? `part-number-link${isNA ? " part-number-link--na" : ""}`
              : ""
          }
        >
          {" "}
          {props.maxLength > 0
            ? props.label === "Part Numbers"
              ? (isNA ? props.data : parseToLink(props.data, props.maxLength, props.pubId))
              : props.parseString(props.data, props.maxLength)
            : props.data}
        </span>

        {props.viewAllShow && (
          <>
            {t(LABELKEYS_SEARCH_RESULTS.COMMA_SEPARATOR)}{" "}
            <ViewAll headerTitle={props.label} data={props.data} pubId={props.pubId}/>
          </>
        )}
      </div>
    </div>
  );
};

export default MetaDataDisplay;